<template>
    <div>
        <div class="p-grid">
            <div>
                {{ $page.props.session_role.name }}
            </div>
            <app-menu-bar title="Form User" back_url="/users"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Nama </label>
                        <div class="col-12 md:col-10">
                            <InputText id="name" type="text" :class="{'p-invalid' : errors.name}" v-model="form.name" />
                            <small v-if="errors.name" id="name-help" class="p-error">Nama Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="email" class="col-12 mb-2 md:col-2 md:mb-0" :class="{'p-invalid' : errors.email}">Email </label>
                        <div class="col-12 md:col-10">
                            <InputText id="email" type="text" v-model="form.email" />
                            <small v-if="errors.email" id="name-help" class="p-error">{{errors.email}}</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="password" class="col-12 mb-2 md:col-2 md:mb-0">Password </label>
                        <div class="col-12 md:col-10"  :class="{'p-invalid' : errors.password}">
                            <Password id="password" v-model="form.password" toggleMask>
                                <template #header>
                                    <h6>Password Strength : </h6>
                                </template>
                                <template #footer="sp">
                                    {{sp.level}}
                                    <Divider />
                                    <p class="mt-2">Saran Password : </p>
                                    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                        <li>Paling sedikit satu karakter huruf kecil</li>
                                        <li>Paling sedikit satu karakter huruf besar</li>
                                        <li>Paling sedikit satu karakter angka</li>
                                        <li>Minimal panjang password 8 karakter</li>
                                    </ul>
                                </template>
                            </Password>
                            <small v-if="errors.password" id="name-help" class="p-error">{{errors.password}}</small>
                        </div>
                    </div>
                    <RolesInput v-model="form.list_roles" />
                    <div class="field grid">
                        <PermissionTreeTable v-model="form.permissions" title="Additional Permissions"> </PermissionTreeTable>
                    </div>
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import MultiSelect from 'primevue/multiselect';
import PermissionTreeTable from '../../Components/PermissionTreeTable';

import RolesInput from "./Partials/RolesInput.vue";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column, 
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        PermissionTreeTable,
        RolesInput
    },
    props : {
        errors : Array,
        additional_data : Array,
    },
    data : function(){
        return {
                form : {
                    name : '',
                    email : '',
                    password : '',
                    roles : [],
                    permissions : [],
                    list_roles : [],
                },
            }
    },
    methods : {
        submitForm(){
            // alert(this.form)
            Inertia.post('/users/', this.form);
        }
    }
}
</script>
